import { useEffect, useState, useCallback } from 'react';

import ProcessoService from '@services/ProcessoService';

const useUfs = (processo) => {
    const [ data, setData ] = useState([]);
    const [ loading, setLoading ] = useState(false);
    const [ error, setError ] = useState(null);

    const fetchData = useCallback(() => {
        setLoading(true);

        if (!processo)
            return;

        ProcessoService.listarUf(processo)
            .then(res => setData(res.data.map(uf => ({ label : uf, value : uf }) )))
            .catch(err => setError(err))
            .finally(() => setLoading(false));
    }, [processo]);

    useEffect(() => fetchData(), [fetchData]);

    return { data, loading, error };
}

export default useUfs;